import type { ReleaseStatus } from "../api/releases";

/**
 * Display labels for the stored status values. The wire values are
 * `upcoming | in_progress | completed`; the mockup renders the first as
 * "Not started". Change wording here — never in stored data.
 */
export const RELEASE_STATUS_LABELS: Record<ReleaseStatus, string> = {
  upcoming: "Not started",
  in_progress: "In Progress",
  completed: "Completed",
};

export const RELEASE_STATUSES: ReleaseStatus[] = [
  "upcoming",
  "in_progress",
  "completed",
];

export const RELEASE_STATUS_OPTIONS = RELEASE_STATUSES.map((status) => ({
  value: status,
  label: RELEASE_STATUS_LABELS[status],
}));

export const DEFAULT_RELEASE_STATUS: ReleaseStatus = "upcoming";



/**
 * The synthetic parent node the group→release tree hangs its releases under.
 * A group is not a release, so its option value is prefixed to keep it out of
 * any set that gets submitted as `releaseIds` — the same trick the
 * product-area tree plays with its synthetic domain rows, except that domains
 * *are* legitimate filter values and release groups are not.
 */
export const RELEASE_GROUP_OPTION_PREFIX = "release-group:";

/** `option.type` on those synthetic parents. */
export const RELEASE_GROUP_OPTION_TYPE = "release-group";

/**
 * The filter/picker key. The backend registers the ideas-list filter under
 * exactly this name (`{name:'release', filterObject:'idea', type:'checkbox',
 * dbFieldPath:'productItem.releaseIds'}`), and the picker reuses it so one
 * `release` branch in CheckboxFilter serves both.
 */
export const RELEASE_FILTER_KEY = "release";

/** Placeholder in the ideas row control when nothing is assigned. */
export const RELEASE_EMPTY_LABEL = "Select release";

/**
 * Why a release control is disabled when it has nothing to write to — a theme
 * row on the Bagel AI tab, or an idea that has not loaded yet. An idea needs
 * no delivery link to carry releases of its own.
 */
export const RELEASE_NO_TARGET_TOOLTIP =
  "Releases are assigned on an idea, and there is no idea to assign one to here.";

/** Header for the read-only second set on the idea detail view. */
export const RELEASE_DELIVERY_ITEM_LABEL = "On delivery item";

/** Marks a release in the chip tooltip as coming from the linked delivery item, not the idea. */
export const RELEASE_DELIVERY_ITEM_SUFFIX = "(on delivery item)";

export const RELEASE_DELIVERY_ITEM_TOOLTIP =
  "Releases on the linked delivery item. A separate set from this idea's own releases — edit them on the delivery item.";
